<section class="container-xxl container-xl container-lg container-md container-sm text-center news-section">
  <h3 class="header_text rdj_bold">News & Events</h3>


  <div class="our_news d-flex flex-wrap justify-content-between gap-3   ">

    <article class="">
      <div class=" news-card">
        <div class="card-thumbnail d-flex align-items-center ">
          <div class="card_image w-50">
            <img src="assets/imgs/reception_2.png" class="img-fluid " alt="">
          </div>

          <div class="thumbnail-text w-50 p-4">
            <h3 class="">
              <a href="">
                <b>Zumera Tower: A 7-in-1 Masterpiece</b>
              </a>
            </h3>
            <a href="/news">Read More <span class="read-arrow">&#8594;</span></a>
          </div>
        </div>
             
      </div>
  
    </article>

    <article class="">
      <div class=" news-card">
        <div class="card-thumbnail d-flex align-items-center ">
          <div class="card_image w-50">
            <img src="assets/imgs/home-bg-2.jpg" class="img-fluid " alt="">
          </div>

          <div class="thumbnail-text w-50 p-4">
            <h3 class="">
              <a href="">
                <b>Benin City: Why We Chose The Ancient City</b>
              </a>
            </h3>
            <a href="/news">Read More <span class="read-arrow">&#8594;</span></a>
          </div>
        </div>
             
      </div>
  
    </article>


  </div>
</section>